export const ROOT_CONTAINER_KEY = 'rootContainer' as const;
